import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader2, Copy, Users, FilePlus2 } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

// Iter 119: "Nuovo programma" sempre disponibile: scegli data e base di partenza
export default function NuovoProgrammaDialog({ open, onClose, defaultDate, onCreated }) {
  const [data, setData] = useState(defaultDate);
  const [busy, setBusy] = useState("");
  const crea = async (da) => {
    if (!data) return;
    setBusy(da);
    try {
      const { data: r } = await api.post(`/programma/${data}/init`, null, { params: { da } });
      toast.success(r.copiato_da === "anagrafiche" ? "Programma creato dalle ubicazioni delle anagrafiche" : r.copiato_da === "vuoto" ? "Programma vuoto creato" : `Programma copiato dal ${r.copiato_da}`);
      onCreated?.(data); onClose();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Creazione non riuscita");
    } finally { setBusy(""); }
  };
  const opts = [
    { k: "precedente", icon: Copy, l: "Copia dall'ultimo giorno programmato", d: "Parti dal giorno precedente e sposta solo le differenze (consigliato)" },
    { k: "anagrafiche", icon: Users, l: "Dalle ubicazioni in anagrafica", d: "Ogni persona/mezzo nella sede abituale salvata in Risorse" },
    { k: "vuoto", icon: FilePlus2, l: "Vuoto", d: "Colonne dei cantieri vuote: aggiungi tu le persone con “+ Aggiungi”" },
  ];
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="nuovo-programma-dialog">
        <DialogHeader><DialogTitle className="font-heading">Nuovo programma giornaliero</DialogTitle></DialogHeader>
        <label className="text-sm font-semibold flex items-center gap-2">Data
          <input type="date" value={data} onChange={(e) => setData(e.target.value)} className="rounded border px-2 py-1 text-sm font-bold" data-testid="nuovo-programma-data" />
        </label>
        <div className="space-y-2">
          {opts.map((o) => (
            <Button key={o.k} variant="outline" disabled={!!busy} onClick={() => crea(o.k)} data-testid={`nuovo-programma-${o.k}`} className="w-full h-auto justify-start text-left py-2 whitespace-normal">
              {busy === o.k ? <Loader2 className="h-4 w-4 mr-2 animate-spin shrink-0" /> : <o.icon className="h-4 w-4 mr-2 shrink-0 text-[#0044FF]" />}
              <span><span className="font-bold block">{o.l}</span><span className="text-xs text-slate-500">{o.d}</span></span>
            </Button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
